<script setup lang="ts">
import { useCommonStore } from '@/stores/modules/common'
import { useUserStore } from '@/stores/modules/user'
import type { RuneTempleRankType } from '@/types/dungeon'
import { formatMs } from '@/utils'
import { socketEmitAsync } from '@/utils/web-socket'
import { onMounted, ref } from 'vue'

const commonStore = useCommonStore()
const userStore = useUserStore()

const rankList = ref<RuneTempleRankType[]>([])
async function getRuneTowerRank() {
  const res = await socketEmitAsync<RuneTempleRankType[]>({ type: 'getRuneTempleRank' })
  rankList.value = res
}
const refreshTime = ref(0)
function handleRefresh() {
  refreshTime.value = 60
  const interval = setInterval(() => {
    refreshTime.value--
    if (refreshTime.value <= 0) clearInterval(interval)
  }, 1000)
  getRuneTowerRank()
}

onMounted(() => {
  getRuneTowerRank()
})
</script>

<template>
  <div class="rune-tower-rank">
    <h4>符石神殿排行</h4>
    <el-button size="small" type="primary" plain @click="handleRefresh" style="margin-bottom: 10px" :disabled="refreshTime > 0">
      {{ refreshTime > 0 ? `请等待（${refreshTime}s）` : '刷新' }}
    </el-button>
    <el-table
      :data="rankList"
      border
      style="width: 100%; height: 49vh"
      :row-class-name="({ row }: any) => (row.id === userStore.id ? 'personal' : '')"
      size="small"
      v-loading="commonStore.loading"
    >
      <el-table-column prop="rank" label="排位" width="50">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称">
        <template #default="{ row }">
          <span class="nickname" :style="{ background: row.color }">{{ row.nickname }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="useTime" label="击败时间" width="70">
        <template #default="{ row }"> {{ formatMs(row.useTime) }} </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss" scoped>
.rune-tower-rank {
  :deep() {
    .el-table {
      .personal {
        --el-table-tr-bg-color: var(--el-color-danger-light-7);
      }
    }
  }
}
</style>
